import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateTaskToDo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 500,
	height: 500,
	viewBox: "0 0 500 500",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M269.424 492.202C394.985 492.202 496.772 390.414 496.772 264.853C496.772 139.292 394.985 37.5044 269.424 37.5044C143.863 37.5044 42.0752 139.292 42.0752 264.853C42.0752 390.414 143.863 492.202 269.424 492.202Z",
			fill: "#EEF5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M305.425 48.7874C314.808 46.9635 323.925 53.113 325.749 62.4961L380.154 342.385C381.978 351.769 375.828 360.886 366.445 362.71L177.3 399.475C167.917 401.299 158.799 395.15 156.976 385.767L102.571 105.877C100.747 96.4943 106.897 87.3772 116.28 85.5533L305.425 48.7874ZM301.893 30.6217L112.749 67.3876C93.3179 71.1646 80.6281 89.9782 84.4049 109.409L138.81 389.298C142.587 408.728 161.4 421.418 180.831 417.641L369.976 380.875C389.407 377.098 402.096 358.285 398.32 338.854L343.915 58.9651C340.138 39.5348 321.324 26.8448 301.893 30.6217Z",
			fill: "#A8CCFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M305.424 48.7872C314.807 46.9633 323.925 53.1127 325.749 62.4959L380.154 342.385C381.978 351.768 375.828 360.885 366.444 362.709L177.3 399.475C167.917 401.299 158.799 395.15 156.975 385.767L102.57 105.877C100.746 96.4941 106.896 87.377 116.28 85.5531L305.424 48.7872Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M173.313 237.376L180.562 242.265L190.864 226.992",
			stroke: "white",
			strokeWidth: 5.2598,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M207.115 123.957L249.128 115.791",
			stroke: "#E0EEFE",
			strokeWidth: 7.10167,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M211.584 146.946L302.744 129.226",
			stroke: "#E0EEFE",
			strokeWidth: 7.10167,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M154.626 145.973L162.463 151.267L174.449 133.525",
			stroke: "#E0EEFE",
			strokeWidth: 5.59627,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M164.537 168.793C178.623 168.793 190.041 157.374 190.041 143.289C190.041 129.204 178.623 117.786 164.537 117.786C150.452 117.786 139.034 129.204 139.034 143.289C139.034 157.374 150.452 168.793 164.537 168.793Z",
			stroke: "#E0EEFE",
			strokeWidth: 6.99534,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M224.755 214.237L266.768 206.071",
			stroke: "#E0EEFE",
			strokeWidth: 7.10167,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M229.223 237.225L320.383 219.506",
			stroke: "#E0EEFE",
			strokeWidth: 7.10167,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M172.177 237.312L180.014 242.606L192 224.865",
			stroke: "#E0EEFE",
			strokeWidth: 5.59627,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M182.089 260.132C196.174 260.132 207.592 248.713 207.592 234.628C207.592 220.543 196.174 209.125 182.089 209.125C168.004 209.125 156.585 220.543 156.585 234.628C156.585 248.713 168.004 260.132 182.089 260.132Z",
			stroke: "#E0EEFE",
			strokeWidth: 6.99534,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M244.414 307.372L286.427 299.205",
			stroke: "#E0EEFE",
			strokeWidth: 7.10167,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M248.883 330.36L340.043 312.64",
			stroke: "#E0EEFE",
			strokeWidth: 7.10167,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M191.866 330.076L199.703 335.37L211.689 317.628",
			stroke: "#E0EEFE",
			strokeWidth: 5.59627,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M201.778 352.896C215.863 352.896 227.281 341.477 227.281 327.392C227.281 313.307 215.863 301.889 201.778 301.889C187.693 301.889 176.274 313.307 176.274 327.392C176.274 341.477 187.693 352.896 201.778 352.896Z",
			stroke: "#E0EEFE",
			strokeWidth: 6.99534,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M392.198 333.016C428.685 333.016 458.263 303.437 458.263 266.951C458.263 230.465 428.685 200.887 392.198 200.887C355.712 200.887 326.134 230.465 326.134 266.951C326.134 303.437 355.712 333.016 392.198 333.016Z",
			fill: "#76AFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M392.198 233.906V298.598",
			stroke: "#EEF5FF",
			strokeWidth: 11.4892,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M424.544 266.252H359.852",
			stroke: "#EEF5FF",
			strokeWidth: 11.4892,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M200.926 32.8803C206.024 32.8803 210.156 28.7477 210.156 23.6499C210.156 18.552 206.024 14.4194 200.926 14.4194C195.828 14.4194 191.695 18.552 191.695 23.6499C191.695 28.7477 195.828 32.8803 200.926 32.8803Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M172.135 43.5734L235.072 31.3868C255.235 27.4825 274.775 40.6829 278.68 60.8464L279.318 64.1437C280.038 67.863 277.603 71.4673 273.884 72.1875L151.358 95.9125C147.639 96.6327 144.034 94.1978 143.314 90.4784L142.676 87.1811C138.771 67.0177 151.972 47.4777 172.135 43.5734Z",
			fill: "#FFCE00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M197.939 8.22531C210.502 5.79275 222.676 14.0172 225.109 26.58L227.557 39.224L182.033 48.0391L179.584 35.395C177.152 22.8322 185.376 10.6579 197.939 8.22531Z",
			fill: "#FFCE00"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_2046_441315",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 141,
			y: 30,
			width: 139,
			height: 67,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M172.135 43.5734L235.072 31.3868C255.235 27.4825 274.775 40.6829 278.68 60.8464L279.318 64.1437C280.038 67.863 277.603 71.4673 273.884 72.1875L151.358 95.9125C147.639 96.6327 144.034 94.1978 143.314 90.4784L142.676 87.1811C138.771 67.0177 151.972 47.4777 172.135 43.5734Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_2046_441315)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M287.075 59.3042L134.312 88.8843L137.093 103.247L289.856 73.6666L287.075 59.3042Z",
				fill: "#FFBA00"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M486.909 342.512C491.394 342.512 495.029 338.876 495.029 334.392C495.029 329.907 491.394 326.272 486.909 326.272C482.424 326.272 478.789 329.907 478.789 334.392C478.789 338.876 482.424 342.512 486.909 342.512Z",
			fill: "#A8CCFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1438 254.582C31.0387 254.582 39.0601 246.561 39.0601 236.666C39.0601 226.771 31.0387 218.75 21.1438 218.75C11.2489 218.75 3.22754 226.771 3.22754 236.666C3.22754 246.561 11.2489 254.582 21.1438 254.582Z",
			fill: "#E0EEFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.7439 97.4029C67.1545 97.4029 71.5406 93.0168 71.5406 87.6062C71.5406 82.1957 67.1545 77.8096 61.7439 77.8096C56.3334 77.8096 51.9473 82.1957 51.9473 87.6062C51.9473 93.0168 56.3334 97.4029 61.7439 97.4029Z",
			fill: "#A8CCFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M368.301 43.3953C376.874 43.3953 383.823 36.4456 383.823 27.8727C383.823 19.2998 376.874 12.3501 368.301 12.3501C359.728 12.3501 352.778 19.2998 352.778 27.8727C352.778 36.4456 359.728 43.3953 368.301 43.3953Z",
			fill: "#E0EEFE"
		})
	]
});
export default SvgEmptyStateTaskToDo;
